<script setup>
import { computed } from 'vue';
const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const routeName = computed(() => `${props.row.original.type}_reports_show`);
</script>

<template>
  <router-link
    v-if="row.original.linkEnabled"
    :to="{ name: routeName, params: { id: row.original.id } }"
    class="text-n-slate-12 hover:underline"
  >
    {{ row.original.name }}
  </router-link>
  <span v-else class="text-n-slate-12">
    {{ row.original.name }}
  </span>
</template>
